// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2gTqt","content":"LayoutSettings_content__3urR8"};